
(function () {
  "use strict";

  // Prevent the same script from being initialized twice.
  if (window.kidonexWhatsAppInitialized) return;
  window.kidonexWhatsAppInitialized = true;

  var phone = "917593030800";
  var processing = false;

  function formatPrice(amount, currency) {
    return (amount / 100).toLocaleString("en-IN", {
      style: "currency",
      currency: currency || "INR"
    });
  }

  document.addEventListener("click", async function (event) {
    var button = event.target.closest(
  "#kidonex-whatsapp-order, #kidonex-fullcart-whatsapp"
);

    if (!button) return;

    event.preventDefault();

    if (processing) return;
    processing = true;

    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = "Preparing your order...";

    // Open immediately while the browser recognizes the click.
    var whatsappTab = window.open("about:blank", "_blank");

    var controller = new AbortController();
    var timeout = setTimeout(function () {
      controller.abort();
    }, 10000);

    try {
      var root =
        window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root
          : "/";

      var response = await fetch(root + "cart.js", {
        method: "GET",
        cache: "no-store",
        credentials: "same-origin",
        signal: controller.signal
      });

      if (!response.ok) {
        throw new Error("Cart request failed: " + response.status);
      }

      var cart = await response.json();

      if (!cart.items || cart.items.length === 0) {
        if (whatsappTab && !whatsappTab.closed) {
          whatsappTab.close();
        }
        alert("Your cart is empty.");
        return;
      }

      var currency = cart.currency || "INR";

      var lines = cart.items.map(function (item, index) {
        var variant =
          item.variant_title &&
          item.variant_title !== "Default Title"
            ? " (" + item.variant_title + ")"
            : "";

        return (
          (index + 1) + ". " +
          item.product_title +
          variant +
          "\nQuantity: " + item.quantity +
          "\nPrice: " +
          formatPrice(item.final_line_price, currency)
        );
      });

      var message =
        "*KIDONEX - NEW ORDER REQUEST*\n\n" +
        "Hello Kidonex, I would like to place an order.\n\n" +
        "*ITEMS IN CART*\n\n" +
        lines.join("\n\n") +
        "\n\nSubtotal: " +
        formatPrice(cart.items_subtotal_price, currency) +
        "\nDelivery Charges: To be confirmed" +
        "\nFinal Total: To be confirmed" +
        "\n\nPlease confirm availability, delivery charges, " +
        "and provide the next steps to complete my order." +
        "\n\nThank you";

      var url =
        "https://wa.me/" +
        phone +
        "?text=" +
        encodeURIComponent(message);

      if (whatsappTab && !whatsappTab.closed) {
        whatsappTab.location.replace(url);
      } else {
        // Fallback if opening a new tab was blocked.
        window.location.assign(url);
      }

    } catch (error) {
      console.error("KIDONEX WhatsApp error:", error);

      if (whatsappTab && !whatsappTab.closed) {
        whatsappTab.close();
      }

      if (error.name === "AbortError") {
        alert("Connection timed out. Please try again.");
      } else {
        alert("Unable to prepare your order. Please try again.");
      }

    } finally {
      clearTimeout(timeout);
      processing = false;
      button.disabled = false;
      button.textContent = originalText;
    }
  });
})();
